import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavItem, NavItemsType} from '@pt/pt-models';
import {NgxPermissionsService} from 'ngx-permissions';

@Component({
  selector: 'pt-sidebar-item-title',
  template: `
    <div
      *ngSwitchCase='T.TITLE'
      class='sidebar-title'
      [ngClass]='{"sidebar-title--collapsed": collapsed}'>
      <label *ngIf='!collapsed'>
        {{item?.label | async}}
      </label>
    </div>
  `,
  styles: [`
    .sidebar-title {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-direction: row;
      width: 100%;
      height: 36px;
      cursor: pointer;
    }

    .sidebar-title * {
      cursor: pointer;
    }

    .sidebar-title:hover {
      opacity: .8;
    }

    .sidebar-title:focus {
      outline: none;
    }

    .sidebar-title label {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 0;
    }

    .sidebar-title--collapsed {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  `]
})
export class SidebarItemTitleComponent implements OnInit {

  @Input() item: NavItem;
  @Input() collapsed: boolean;
  @Output() clickItem = new EventEmitter<NavItem>();

  T = NavItemsType;
  isEnabled = true;

  constructor(private permissionService: NgxPermissionsService) {
  }

  ngOnInit(): void {
    this.permissionService.hasPermission(this.item.permissEnabled).then((enabled) => {
      this.isEnabled = enabled;
    });
  }
}
